var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "basicInfoForm",
          staticClass: "form-container",
          attrs: { model: _vm.form, size: "small", "label-width": "120px" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "关注点", prop: "focus" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入关注点",
                          readonly: !_vm.$parent.checkPer([
                            "admin",
                            "cust:edit",
                          ]),
                        },
                        on: { input: _vm.syncData },
                        model: {
                          value: _vm.form.focus,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "focus", $$v)
                          },
                          expression: "form.focus",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "需求产品" } },
                    [
                      _vm._l(_vm.form.needProduct1, function (item) {
                        return _c(
                          "el-tag",
                          { key: item, staticStyle: { "margin-right": "2px" } },
                          [_vm._v(_vm._s(item))]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.form.needProduct2, function (item) {
                        return _c(
                          "el-tag",
                          { key: item, staticStyle: { "margin-right": "2px" } },
                          [_vm._v(_vm._s(item))]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.form.needProduct3, function (item) {
                        return _c(
                          "el-tag",
                          { key: item, staticStyle: { "margin-right": "2px" } },
                          [_vm._v(_vm._s(item))]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户预算", prop: "budget" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入客户预算",
                          readonly: !_vm.$parent.checkPer([
                            "admin",
                            "cust:edit",
                          ]),
                        },
                        on: { input: _vm.syncData },
                        model: {
                          value: _vm.form.budget,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "budget", $$v)
                          },
                          expression: "form.budget",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "材料", prop: "material" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入材料",
                          readonly: !_vm.$parent.checkPer([
                            "admin",
                            "cust:edit",
                          ]),
                        },
                        model: {
                          value: _vm.form.material,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "material", $$v)
                          },
                          expression: "form.material",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          placeholder: "请输入备注",
                          readonly: !_vm.$parent.checkPer([
                            "admin",
                            "cust:edit",
                          ]),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "预算图" } }, [
                    _vm.$parent.checkPer(["admin", "cust:edit"])
                      ? _c(
                          "div",
                          [
                            _c("CommonUpload", {
                              ref: "commonUpload",
                              on: {
                                uploadSuccess: _vm.uploadImgs,
                                delSuccess: _vm.delImg,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowImgs &&
                    _vm.form.budgetImgs != null &&
                    _vm.form.budgetImgs.length > 0
                      ? _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          _vm._l(
                            _vm.imgUrl(_vm.form.budgetImgs),
                            function (url, index) {
                              return _c(
                                "div",
                                {
                                  key: url,
                                  staticStyle: {
                                    float: "left",
                                    "margin-right": "10px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      height: "147px",
                                      width: "147px",
                                      "border-radius": "5px",
                                    },
                                    attrs: {
                                      src: url,
                                      "preview-src-list": _vm.imgUrl(
                                        _vm.form.budgetImgs
                                      ),
                                      fit: "contain",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.$parent.checkPer(["admin", "cust:edit"])
                                    ? _c("span", {
                                        staticClass: "el-icon-delete-solid",
                                        on: {
                                          click: function ($event) {
                                            return _vm.delImgIndex(index)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-top": "20px" } },
        [
          _vm.$parent.checkPer(["admin", "cust:edit"])
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveBasicInfo },
                },
                [_vm._v("\n      保存\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }